export default {
  summaryLine: '{series} series · {rows} filas',
  startDateHelp: 'Cada fila se cuenta en el período que contiene su Start Date. Los períodos sin filas quedan vacíos, no en cero.',
  week: 'Semanal',
  month: 'Mensual',
  quarter: 'Trimestral',
  year: 'Anual',
  metric: 'Métrica',
  filter: 'Filtro',
  variable: 'Variable',
  allVariables: 'Todas las variables',
  byVariable: 'Por variable',
  allData: 'Todos los datos',
  blankValue: '(vacío)',
  filterUnavailableValues: 'Demasiados valores para filtrar',
  filterUnavailableSize: 'No disponible para un template de este tamaño',
  flaggedOnly: 'Solo series a revisar',
  showSpecialDates: 'Mostrar fechas especiales',
  fixedDims: 'Todas las filas tienen {list}',
  bucketedNotice: 'Esta hoja tiene datos diarios, así que la vista más detallada es semanal.',
  noSeries: 'Ninguna serie coincide con esta selección',
  coverageTitle: 'Cobertura',
  coverageHelp: 'Cada fila es una serie y cada columna un período. Las celdas más oscuras son valores más altos dentro de esa serie; las blancas son períodos sin datos. Busca huecos y series que empiecen o terminen en fechas raras.',
  coverageHelpByBrand: 'Cada fila es un competidor (todos sus medios sumados) y cada columna un período. Las celdas más oscuras son valores más altos dentro de ese competidor; las blancas son períodos sin datos. Busca huecos y competidores que empiecen o terminen en fechas raras.',
  seriesTitle: 'Series',
  showMore: 'Mostrar {count} más',
  issueMissingColumns: 'Columnas no encontradas: {list}',
  issueBadDates: 'Se omitieron {count} filas porque no se pudo leer su Start Date.',
  issueTextDates: '{count} filas tienen fechas escritas como texto. Revisa que los días y los meses no estén invertidos.',
  issueNonNumeric: '{count} valores no son números y se dejaron fuera.',
  issueDroppedSeries: 'Se muestran las {shown} series con más filas (otras {hidden} no se muestran).'
}
